// Polyfills for browser compatibility with Node.js modules
import 'zone.js';

// Polyfill for global
if (typeof global === 'undefined') {
  (window as any).global = window;
}

// Polyfill for process
if (typeof process === 'undefined') {
  (window as any).process = {
    env: {},
    version: '',
    platform: 'browser',
    nextTick: (callback: () => void) => setTimeout(callback, 0)
  };
}

// Polyfill for Buffer
if (typeof Buffer === 'undefined') {
  (window as any).Buffer = require('buffer').Buffer;
}

// Polyfill for stream module
if (typeof (window as any).stream === 'undefined') {
  (window as any).stream = require('stream-browserify');
}
